import type { SVGProps } from 'react';
const SvgSignalCellularOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#signal_cellular_off_svg__a)">
      <path
        fill="currentColor"
        d="m21 1-8.59 8.59L21 18.18V1ZM4.77 4.5 3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5Z"
      />
    </g>
    <defs>
      <clipPath id="signal_cellular_off_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSignalCellularOff;
